import "./FeaturesText.css"

export default function FeaturesText({ children }) {
    return (
        <div className="App-page-right-text-features">
            {children}            
        </div>
    )
}